module.exports = __webpack_public_path__ + "img/Nara-02.f4a63378.jpg";